import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Zap, Users, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="pt-10 pb-12 md:pt-16 md:pb-16 px-4 bg-brand-black relative overflow-hidden" data-id="element-51">
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[500px] h-[500px] bg-brand-green/10 rounded-full blur-[120px] pointer-events-none" data-id="element-52"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-53">
        {/* TITLE */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] uppercase mb-8" data-id="element-54">
          Dominá el pádel en 8 semanas con la{' '}
          <span className="text-brand-green" data-id="element-55">ventaja del zurdo</span>
          <span className="text-brand-green" data-id="element-56">.</span>
        </motion.h1>

        {/* MOCKUP */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center mb-8" data-id="element-57">
          <div className="absolute inset-0 bg-brand-green/20 blur-[100px] rounded-full max-w-md mx-auto" data-id="element-58"></div>
          <a href="#compra" className="relative z-10 block" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/rDjjBexQg9MmbJuSv7hUh2/ChatGPT_Image_May_18__2026__01_20_04_AM-removebg-preview.png" alt="Padel Zurdo Pro Bundle" className="w-3/4 max-w-lg mx-auto drop-shadow-2xl" data-id="element-60" />
          </a>
        </motion.div>

        {/* SUBTITLES + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-61">
          <p className="font-body text-base md:text-lg text-gray-300 mb-3 font-medium" data-id="element-62">
            6 Tomos · 6 Bonos · Listo para usar.
          </p>

          <p className="font-body text-sm md:text-base text-gray-400 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-63">
            El sistema definitivo de tácticas, ejercicios y estrategias diseñado
            exclusivamente para jugadores zurdos de pádel.
          </p>

          {/* Badges */}
          <div className="flex flex-wrap justify-center gap-2 mb-7" data-id="element-64">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-xs font-body text-gray-200" data-id="element-65">
              <BookOpen className="w-3.5 h-3.5 text-brand-green" data-id="element-66" /> PDF digital
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-xs font-body text-gray-200" data-id="element-67">
              <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-68" /> Acceso inmediato
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-xs font-body text-gray-200" data-id="element-69">
              <Users className="w-3.5 h-3.5 text-brand-green" data-id="element-70" /> Todos los
              niveles
            </span>
          </div>

          <a href="https://checkout.ebookpoint.shop/cart/59466975805521:1" className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-darkGreen text-brand-black font-display text-base md:text-lg py-4 px-6 rounded-xl transition-all transform hover:scale-[1.02] hover:shadow-xl hover:shadow-brand-green/30 w-full md:w-auto" data-id="element-71">
            💥 → QUIERO USAR MI ZURDA COMO VENTAJA
          </a>

          {/* Trust row */}
          <div className="flex flex-wrap items-center justify-center gap-4 mt-5 text-xs font-body text-gray-400" data-id="element-72">
            <div className="flex items-center gap-1.5" data-id="element-73">
              <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-74" />
              <span data-id="element-75">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-76">
              <Lock className="w-4 h-4 text-brand-green" data-id="element-77" />
              <span data-id="element-78">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-79">
              <CreditCard className="w-4 h-4 text-brand-green" data-id="element-80" />
              <span data-id="element-81">Mercado Pago · Tarjeta</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}